var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"product-comments-list"},_vm._l((_vm.commentsForRender),function(comment){return _c('CommentItem',{key:comment.comment_id,attrs:{"is-short":_vm.isShort,"comment":comment,"endpoint":_vm.endpoint,"product-id":_vm.productId,"is-questions":_vm.isQuestions}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }